module.exports = __webpack_public_path__ + "static/img/left-pic-1.239b732f.png";